/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { ComplexDependencies } from './dependenciesComplexClass.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createLog10 } from '../../factoriesAny.js';
export var log10Dependencies = {
  ComplexDependencies: ComplexDependencies,
  typedDependencies: typedDependencies,
  createLog10: createLog10
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLog10.generated.js
// module id = 1579
// module chunks = 0